window.UpsellGlobalFunction = function(){
//Upsell Add to cart function
function upsellAddTocart(){
  document.querySelectorAll('.product-upsell-add').forEach(function(e){
    e.addEventListener('click',function(element){
      let variantId = element.target.getAttribute('data-variant-id'),
          qty = 1,
          formData = { "items": [
                    {
                      "id": variantId,
                      "quantity": qty
                   }
                ]}
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json'}, body: JSON.stringify(formData)})
              .then(response => {
              return response.json();
            }).then(cartData=>{
                  document.location.reload();  
            })
              .catch((error) => {
              console.error('Error:', error);
          });
    });
  });
}
 // upsellAddTocart();
}
// window.UpsellGlobalFunction();

//Product Page Free Shipping HTML 
// setTimeout(function(){
//   if(document.querySelector(".product-info__fs")){
//   const node = document.querySelector(".product-info__fs");
//   const clone = node.cloneNode(true);
//   node.remove();
//   document.querySelector('.product-form__submit').insertAdjacentElement('afterend', clone);
//   }
// },4000)

document.querySelector(".header__icon.header__icon--search.header__icon--summary.link.focus-inset.modal__toggle").addEventListener("click", () => {
  setTimeout(function(){
    document.getElementById("Search-In-Modal").focus();
  });
});


window.SlickInit = function (){
  $('.slider-cart-upsell').slick({
    // infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    variableWidth: false
  });
} 

window.SlickInit();
// if($('.slider-cart-upsell').length > 0){
// window.SlickInit();
// }

function getQueryVariable(variable)
{
   var query = window.location.search.substring(1);
   var vars = query.split("&");
   for (var i=0;i<vars.length;i++) {
           var pair = vars[i].split("=");
           if(pair[0] == variable){return pair[1];}
   }
   return(false);
}

$('form#retailer').submit(function(e){
    e.preventDefault();
    if($(this).find('input[name="zipcode"]').val() != ' '){
        window.location = 'http://routeoneapparel.com/pages/retailers?zipcode='+$(this).find('input[name="zipcode"]').val()
    }
  });


  if(getQueryVariable('zipcode')){
    var _retailer = setInterval(function(){

      if($('#storemapper-form').length){

        $('#storemapper-zip').val(getQueryVariable('zipcode'));
        $('#storemapper-go').click();

        clearInterval(_retailer);
      }

    }, 500);
  }

if(document.querySelector(".contact-brand-ambassadors .home-hero .home-hero__button span")){
  document.querySelector(".contact-brand-ambassadors .home-hero .home-hero__button span").addEventListener('click',function(){
    let element = document.querySelector(".shopify-section.section.wholesale-form");
    element.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  });  
}

$(".facets__categories-list").each(function(){ 
  $(this).addClass("is-empty");
  console.log('in');
  if($(this).html().trim()==""){
      $(this).parents(".facets__categories").addClass("is-empty");
  }
});

$( document ).ready(function() {

$('.slider-for').slick({
  
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
    });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true
  });
  
}); 

var $small_only = window.matchMedia("(max-width: 767px)"),
	$medium_up = window.matchMedia("(min-width: 768px)"),
	$medium_only = window.matchMedia("(min-width: 768px) and (max-width: 970px)"),
	$large_up = window.matchMedia("(min-width: 971px)"),
	$large_only = window.matchMedia("(min-width: 971px) and (max-width: 1024px)"),
	$xlarge_up = window.matchMedia("(min-width: 1025px)"),
	$xlarge_only = window.matchMedia("(min-width: 1025px) and (max-width: 1240px)");

// set same height for all cssClass-elements on medium-up
function equalizer(cssClass) {
	var wrapper = $(cssClass).parent();
	var x = wrapper.prevObject.length;
	var y = 3; // number of columns
	var quotient = Math.floor(x / y);
	var padding = 10; // user defined distance to bottom
	var max = 0;

	$(cssClass).css('height', 'auto'); // reset
	
	if($medium_up.matches) {
		$(cssClass).each(function(){
			if($(this).height() > max) max = $(this).height() + padding;
		});
		$(cssClass).height(max + padding);	
	}
	
	wrapper.css('margin-bottom', (padding * quotient) + 'px');
}

$(window).on('load resize', function() {
	equalizer('.custom-landing .multicolumn-2 .multicolumn-card__info .rte');
});


let interval = null

let domWorks = () => {
     let d = document.querySelector('div.custom_collection_wrapper')
     if(d){
      $('div.custom_collection_wrapper').not(':eq(0)').hide();
      $('div.custom_collection_wrapper').eq(0).show()
      clearInterval(interval) // Change it via reference
     }
}

interval = setInterval(domWorks, 100)

function getEmpId(element)
{
  var collection_name = element.dataset.collection;
  var ele = document.getElementsByClassName('custom_collection_wrapper');
  const elements = document.querySelectorAll('[data-collections="'+ collection_name +'"]');
  console.log("chk",elements,collection_name)
  if(elements){
   $(ele).hide();
   $(elements).show();
   $('.slider-for').slick('refresh');
   $('html, body').animate({
    scrollTop: $(elements).offset().top - 50
   }, 2000);
  }
}  

$(document).on('click','#viewall',function(){
  const form = document.getElementById('shopify-section-template--14505915318354__1ee8acfa-166a-44ce-b5b2-33afc42f4a55');
  $('html, body').animate({
    scrollTop: $(form).offset().top
   }, 2000);
})
